var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-show=\"mode=='edit'\"><div ng-show=\"signType=='draw'\" class=\"drawSgn\"><a href=\"#\" class=\"fancybox-modal2\"><div ng-click=\"openModal()\" class=\"sign\"><p ng-if=\"!field.value\" class=\"clickto\">{{field.label}}</p><new-signature field=\"field\" mode=\"view\" ng-if=\"field.value\" stage=\"stage\"></new-signature></div><p ng-click=\"doType()\" style=\"bottom:-15px\" class=\"typeto\">Prefer to type your signature? Click here</p></a></div><div ng-show=\"signType=='type'\" class=\"typeSgn\"><signature-text field=\"field\" mode=\"mode\" stage=\"stage\"></signature-text></div></div><div ng-show=\"mode=='view'\"><div ng-show=\"signType=='draw'\" class=\"drawSgn\"><new-signature field=\"field\" mode=\"view\" stage=\"stage\"></new-signature></div><div ng-show=\"signType=='type'\" class=\"typeSgn\"><signature-text field=\"field\" mode=\"view\" stage=\"stage\"></signature-text></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/newSignatureModal/signatureBase.jade
// module id = 350
// module chunks = 0